export var AppSysKey;
(function (AppSysKey) {
    AppSysKey["WEB"] = "WEB";
})(AppSysKey || (AppSysKey = {}));
export var RetCalculatorAge;
(function (RetCalculatorAge) {
    RetCalculatorAge["Age"] = "A";
})(RetCalculatorAge || (RetCalculatorAge = {}));
export var MoneySourceTaxBasis;
(function (MoneySourceTaxBasis) {
    MoneySourceTaxBasis["BeforeTax"] = "P";
    MoneySourceTaxBasis["AfterTax"] = "A";
})(MoneySourceTaxBasis || (MoneySourceTaxBasis = {}));
export var RetContributionRtTyCd;
(function (RetContributionRtTyCd) {
    RetContributionRtTyCd["Dollar"] = "D";
    RetContributionRtTyCd["Percent"] = "P";
})(RetContributionRtTyCd || (RetContributionRtTyCd = {}));
export var RICContributionRtIncrVal;
(function (RICContributionRtIncrVal) {
    RICContributionRtIncrVal[RICContributionRtIncrVal["Half"] = 0.5] = "Half";
    RICContributionRtIncrVal[RICContributionRtIncrVal["Number"] = 1] = "Number";
    RICContributionRtIncrVal[RICContributionRtIncrVal["Quarter"] = 0.25] = "Quarter";
    RICContributionRtIncrVal[RICContributionRtIncrVal["Tenth"] = 0.1] = "Tenth";
    RICContributionRtIncrVal[RICContributionRtIncrVal["Unlimited"] = 0.01] = "Unlimited";
})(RICContributionRtIncrVal || (RICContributionRtIncrVal = {}));
export var RICContributionRtIncrCd;
(function (RICContributionRtIncrCd) {
    RICContributionRtIncrCd["Half"] = "H";
    RICContributionRtIncrCd["Number"] = "N";
    RICContributionRtIncrCd["Quarter"] = "Q";
    RICContributionRtIncrCd["Tenth"] = "T";
    RICContributionRtIncrCd["Unlimited"] = "U"; // any partial percent
})(RICContributionRtIncrCd || (RICContributionRtIncrCd = {}));
export var EmployeeMatchMethodCd;
(function (EmployeeMatchMethodCd) {
    EmployeeMatchMethodCd["Percent"] = "P";
    EmployeeMatchMethodCd["Dollar"] = "D";
})(EmployeeMatchMethodCd || (EmployeeMatchMethodCd = {}));
export var EmployeeMatchTypeCd;
(function (EmployeeMatchTypeCd) {
    EmployeeMatchTypeCd["BasicMatch"] = "1";
    EmployeeMatchTypeCd["TieredMatch"] = "2";
    EmployeeMatchTypeCd["TieredMatchYearsOfService"] = "3";
    EmployeeMatchTypeCd["TieredMatchRangeYearsOfService"] = "4";
})(EmployeeMatchTypeCd || (EmployeeMatchTypeCd = {}));
export var MoneySourceRestrictionCode;
(function (MoneySourceRestrictionCode) {
    MoneySourceRestrictionCode["NOALLCTN"] = "NOALLCTN";
    MoneySourceRestrictionCode["DSGNTCMPNYSTOCK"] = "DSGNTCMPNYSTOCK";
    MoneySourceRestrictionCode["DSGNTEMPMTCH"] = "DSGNTEMPMTCH";
    MoneySourceRestrictionCode["REALESTATEINSDR"] = "REALESTATEINSDR"; // real estate insider in closed real estate window and designate override is N and source has allocation to real estate fund
})(MoneySourceRestrictionCode || (MoneySourceRestrictionCode = {}));
export var RicControlCards;
(function (RicControlCards) {
    RicControlCards["TOTAL"] = "totalCntbCard";
    RicControlCards["CATCHUP"] = "catchUpCntbCard";
    RicControlCards["AGE"] = "retAgeCard";
    RicControlCards["INCOME"] = "incomeCard";
})(RicControlCards || (RicControlCards = {}));
export var RicImpactFilter;
(function (RicImpactFilter) {
    RicImpactFilter["DAILY"] = "daily";
    RicImpactFilter["MONTHLY"] = "monthly";
    RicImpactFilter["YEARLY"] = "yearly";
})(RicImpactFilter || (RicImpactFilter = {}));
export var RicSalaryFilter;
(function (RicSalaryFilter) {
    RicSalaryFilter["HOURLY"] = "hourly";
    RicSalaryFilter["YEARLY"] = "yearly";
})(RicSalaryFilter || (RicSalaryFilter = {}));
export var RicView;
(function (RicView) {
    RicView["ONBOARD"] = "onboard";
    RicView["ONBOARD_TRAN"] = "onboard-transition";
    RicView["EXPENSES"] = "expenses";
    RicView["EDIT"] = "income";
})(RicView || (RicView = {}));
export var RetExpensesCategories;
(function (RetExpensesCategories) {
    RetExpensesCategories["HOUSING"] = "Housing";
    RetExpensesCategories["HEALTHCARE"] = "Healthcare";
    RetExpensesCategories["FOOD"] = "Groceries";
    RetExpensesCategories["TRANSPORTATION"] = "Transportation";
    RetExpensesCategories["LIFESTYLE"] = "Lifestyle";
})(RetExpensesCategories || (RetExpensesCategories = {}));
export var RICCategoryPcts;
(function (RICCategoryPcts) {
    RICCategoryPcts[RICCategoryPcts["Housing"] = 0.4] = "Housing";
    RICCategoryPcts[RICCategoryPcts["Healthcare"] = 0.15] = "Healthcare";
    RICCategoryPcts[RICCategoryPcts["Groceries"] = 0.08] = "Groceries";
    RICCategoryPcts[RICCategoryPcts["Transportation"] = 0.09] = "Transportation";
    RICCategoryPcts[RICCategoryPcts["Lifestyle"] = 0.28] = "Lifestyle";
})(RICCategoryPcts || (RICCategoryPcts = {}));
export var RetContributionTakeHomePayImpact;
(function (RetContributionTakeHomePayImpact) {
    RetContributionTakeHomePayImpact[RetContributionTakeHomePayImpact["Daily"] = 365] = "Daily";
    RetContributionTakeHomePayImpact[RetContributionTakeHomePayImpact["Weekly"] = 52] = "Weekly";
    RetContributionTakeHomePayImpact[RetContributionTakeHomePayImpact["Monthly"] = 12] = "Monthly";
    RetContributionTakeHomePayImpact[RetContributionTakeHomePayImpact["Yearly"] = 1] = "Yearly";
})(RetContributionTakeHomePayImpact || (RetContributionTakeHomePayImpact = {}));
export var StoreStatus;
(function (StoreStatus) {
    StoreStatus["Init"] = "INIT";
    StoreStatus["Busy"] = "BUSY";
    StoreStatus["Error"] = "ERROR";
    StoreStatus["Ready"] = "READY";
})(StoreStatus || (StoreStatus = {}));
export var RetirmentAge;
(function (RetirmentAge) {
    RetirmentAge[RetirmentAge["min"] = 45] = "min";
    RetirmentAge[RetirmentAge["max"] = 85] = "max";
})(RetirmentAge || (RetirmentAge = {}));
export var RICFlag;
(function (RICFlag) {
    RICFlag[RICFlag["Headroom"] = 75] = "Headroom";
})(RICFlag || (RICFlag = {}));
export var AlertNotification;
(function (AlertNotification) {
    AlertNotification["SUCCESS"] = "Success";
    AlertNotification["INFORMATION"] = "Information";
    AlertNotification["WARNING"] = "Warning";
    AlertNotification["ERROR"] = "Error";
})(AlertNotification || (AlertNotification = {}));
export var TooltipText;
(function (TooltipText) {
    TooltipText["catchupTooltipText"] = "Catch-up lets you contribute more than the regular IRS limit. This is generally a benefit for people age 50+. It may apply only when you have maxed out your regular contributions.";
    TooltipText["ifIContributeTooltipText"] = "This reflects your total rate each pay period, and how it may impact your take-home pay based on a before-tax rate. You may have after-tax options not included here.";
    TooltipText["mayHaveToolTipText"] = "This calculator is hypothetical and for illustrative purposes only. It\u2019s not intended to represent performance of any specific investment, which may fluctuate. There\u2019s no assurance that retirement income objectives will be met. It is possible to lose money by investing in securities.";
    TooltipText["ifIWorkUntilToolTipText"] = "This is the age you expect to retire. It's also the age you'll start taking Social Security benefits, unless you indicated otherwise.";
    TooltipText["planRoundedMsg"] = "Value will be rounded to your plan limit interval to the nearest";
})(TooltipText || (TooltipText = {}));
export var AnalyticsEvents;
(function (AnalyticsEvents) {
    AnalyticsEvents["LOAD"] = "load:ricbanner:analytics";
    AnalyticsEvents["NUDGE_MSG"] = "change:ricnudgemessages:analytics";
    AnalyticsEvents["SAVE_CHANGES"] = "click:ricsavechanges:analytics";
})(AnalyticsEvents || (AnalyticsEvents = {}));
export var NudgeTypes;
(function (NudgeTypes) {
    NudgeTypes["GENERAL"] = "general";
    NudgeTypes["GENERAL_SUCCESS"] = "general success";
    NudgeTypes["NOT_MATCH"] = "not at match";
    NudgeTypes["AT_MATCH"] = "at full match";
    NudgeTypes["MATCH_RESCUE"] = "match rescue";
    NudgeTypes["AT_GOAL_SURPLUS"] = "at goal or surplus";
    NudgeTypes["PROJECTED_GOAL_SURPLUS"] = "projected goal or surplus";
    NudgeTypes["PENDING"] = "pending txn";
    NudgeTypes["SALARY_NEEDED"] = "salary needed";
    NudgeTypes["IRS_LIMIT"] = "irs limit";
})(NudgeTypes || (NudgeTypes = {}));
export var RicModalEvents;
(function (RicModalEvents) {
    RicModalEvents["OPEN_REVIEW"] = "open:ricModal:review";
    RicModalEvents["OPEN_REDIRECT"] = "open:ricModal:contribRedirect";
    RicModalEvents["OPEN_STOP_REDIRECT"] = "open:ricModal:stopContrib:Redirect";
    RicModalEvents["OPEN_CANCEL_PENDING_TXN"] = "open:ricModal:cancelPendingTxn";
    RicModalEvents["OPEN_PENDING_TXN"] = "open:ricModal:pendingTxn";
    RicModalEvents["OPEN_CSR_CONFIRM"] = "open:ricModal:csrConfirm";
    RicModalEvents["OPEN_DETAILS_ASSUMPTIONS"] = "open:ricModal:detailsAssumptions";
    RicModalEvents["OPEN_EDIT_SOCIAL_SECURITY"] = "open:ricModal:editSocialSecurity";
    RicModalEvents["OPEN_ADD_OUTSIDE_SAVINGS"] = "open:ricModal:addOutsideSavings";
    RicModalEvents["OPEN_EDIT_OUTSIDE_SAVINGS"] = "open:ricModal:editOutsideSavings";
    RicModalEvents["OPEN_ADD_OTHER_INCOME"] = "open:ricModal:addOtherIncome";
    RicModalEvents["OPEN_EDIT_OTHER_INCOME"] = "open:ricModal:editOtherIncome";
    RicModalEvents["OPEN_EDIT_NONQUAL"] = "open:ricModal:editNonqual";
    RicModalEvents["CONFIRM_REVIEW"] = "confirm:ricModal:review";
    RicModalEvents["CONFIRM_REDIRECT"] = "confirm:ricModal:contribRedirect";
    RicModalEvents["CONFIRM_STOP_REDIRECT"] = "confirm:ricModal:stopContrib:Redirect";
    RicModalEvents["CONFIRM_ACCELERATOR"] = "confirm:ricModal:accelerator";
    RicModalEvents["CONFIRM_CANCEL_PENDING_TXN"] = "confirm:ricModal:cancelPendingTxn";
    RicModalEvents["CONFIRM_PENDING_TXN"] = "confirm:ricModal:pendingTxn";
    RicModalEvents["CONFIRM_CSR_CONFIRM"] = "confirm:ricModal:csrConfirm";
    RicModalEvents["CONFIRM_TXN_CONFIRMATION"] = "confirm:ricModal:Confirmation";
    RicModalEvents["CONFIRM_DELETE_OUTSIDE_SAVINGS"] = "confirm:outsideSavings:DeleteConfirmation";
    RicModalEvents["CONFIRM_DELETE_OTHER_INCOME"] = "confirm:otherIncome:DeleteConfirmation";
    RicModalEvents["CANCEL_REVIEW"] = "cancel:ricModal:review";
    RicModalEvents["CANCEL_REDIRECT"] = "cancel:ricModal:contribRedirect";
    RicModalEvents["CANCEL_STOP_REDIRECT"] = "cancel:ricModal:stopContribRedirect";
    RicModalEvents["CANCEL_ACCELERATOR"] = "cancel:ricModal:accelerator";
    RicModalEvents["CANCEL_CANCEL_PENDING_TXN"] = "cancel:ricModal:cancelPendingTxn";
    RicModalEvents["CANCEL_PENDING_TXN"] = "cancel:ricModal:pendingTxn";
    RicModalEvents["CANCEL_CSR_CONFIRM"] = "cancel:ricModal:csrConfirm";
    RicModalEvents["CANCEL_DELETE_CONFIRMATION"] = "cancel:ricModal:DeleteConfirmation";
    RicModalEvents["CANCEL_DETAILS_ASSUMPTIONS"] = "cancel:RICModal:detailsAssumptions";
    RicModalEvents["CANCEL_TXN_CONFIRMATION"] = "cancel:ricModal:Confirmation";
    RicModalEvents["CANCEL_DELETE_SOURCE"] = "cancel:ricModal:deleteConfirmation";
    RicModalEvents["CANCEL_EDIT_SOCIAL_SECURITY"] = "cancel:ricModal:editSocialSecurity";
    RicModalEvents["CANCEL_EDIT_OUTSIDE_SAVINGS"] = "cancel:ricModal:editOutsideSavings";
    RicModalEvents["CANCEL_EDIT_OTHER_INCOME"] = "cancel:ricModal:editOtherIncome";
    RicModalEvents["CANCEL_EDIT_NONQUAL"] = "cancel:ricModal:editNonqual";
    RicModalEvents["DELETE_SOURCE"] = "delete:source";
})(RicModalEvents || (RicModalEvents = {}));
export var RicTooltipType;
(function (RicTooltipType) {
    RicTooltipType["TOGGLE"] = "toggletip";
    RicTooltipType["TOOL"] = "toooltip";
})(RicTooltipType || (RicTooltipType = {}));
export var RicTooltipPosition;
(function (RicTooltipPosition) {
    RicTooltipPosition["TOP"] = "top";
    RicTooltipPosition["RIGHT"] = "right";
    RicTooltipPosition["BOTTOM"] = "bottom";
    RicTooltipPosition["LEFT"] = "left";
})(RicTooltipPosition || (RicTooltipPosition = {}));
export var ProjectionType;
(function (ProjectionType) {
    ProjectionType["RIC3"] = "RIC3";
    ProjectionType["RIC2"] = "RIC2";
    ProjectionType["ManagedAdvice"] = "MANAGED_ADVICE";
})(ProjectionType || (ProjectionType = {}));
export var DefaultAssumptions;
(function (DefaultAssumptions) {
    DefaultAssumptions[DefaultAssumptions["IncomeReplacementRatio"] = 80] = "IncomeReplacementRatio";
})(DefaultAssumptions || (DefaultAssumptions = {}));
//# sourceMappingURL=constants.js.map